/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class PlanWizardService {
  private planId!: string;
  private companyId!: string;
  private planName!: string;

  public setPlanId(planId: string) {
    this.planId = planId;
  }

  public getPlanId() {
    return this.planId;
  }

  public setCompanyId(companyId: string) {
    this.companyId = companyId;
  }

  public getCompanyId() {
    return this.companyId;
  }

  public setPlanName(planName: string) {
    this.planName = planName;
  }

  public getPlanName() {
    return this.planName;
  }
}
